import {
  accountPaths,
  IUser,
  UserIHaveAcceptedInviteFrom,
} from '@todesktop/shared';
import { QuerySnapshot, doc, collection } from 'firebase/firestore';
import { getData, getCollectionSnapshotWhere } from './common';
import { firestore } from './firestore';
import { callFirebaseFunction } from './functions';

export const getAcceptedUserData = (id: string, userId: string) =>
  getData<IUser>(
    doc(firestore, `/${accountPaths.acceptedAccount(id, userId)}`),
  );

export const getAcceptedUsers = (id: string) =>
  collection(firestore, accountPaths.acceptedAccounts(id));

export const onAcceptedUsersUpdate = (
  id: string,
  handler: (
    arg: UserIHaveAcceptedInviteFrom[],
    snapshot?: QuerySnapshot,
  ) => void,
) => {
  return getCollectionSnapshotWhere<UserIHaveAcceptedInviteFrom>(
    getAcceptedUsers(id),
    { orderBy: { fieldPath: 'email', direction: 'desc' } },
    handler,
  );
};

export const getOwnAcceptedUsers = (id: string) =>
  collection(firestore, accountPaths.acceptedAccounts(id));

export const deleteAcceptedUser = async (
  acceptedUserId: string,
  authentication: any,
) => {
  const removeAcceptedUserFunction = callFirebaseFunction('removeAcceptedUser');
  return await removeAcceptedUserFunction({ acceptedUserId, authentication });
};
